import { useQuery } from '@tanstack/react-query';
import { useOrganizationStore } from '@/core/stores/organization.store';
import { projectMembersService } from '../api/projectMembers.service';
import { PROJECT_KEYS } from './queryKeys';

export function useProjectMembers(projectId: string) {
  const orgId = useOrganizationStore((s) => s.activeOrganizationId);

  return useQuery({
    queryKey: PROJECT_KEYS.members(orgId ?? '', projectId),
    queryFn: ({ signal }) => projectMembersService.getList(projectId, undefined, signal),
    staleTime: 60_000,
    enabled: !!orgId && !!projectId,
  });
}
